import { body, request } from "services/request";

const resource = "api/trailertypes";

const getTrailerTypesWithFamily = () => request(`${resource}/GetList`, { method: "GET" });
const addToFamily = (params: {}) => request(`${resource}/addToFamily`, body(params));
const removeFromFamily = (params: {}) => request(`${resource}/removeFromFamily`, body(params));

export { getTrailerTypesWithFamily, addToFamily, removeFromFamily };
